<template>
  <div class="tab-content">
    <el-dialog
      title="任务中心"
      :visible.sync="dialogVisible"
      width="50%"
      top="5vh"
      :before-close="handleClose"
      class="task-center-dialog"
    >
      <div class="task-center-container">
        <el-form :inline="true" :model="searchForm" class="view-search-form" size="small">
          <el-form-item label="任务名称">
            <el-input
              v-model="searchForm.taskName"
              placeholder="请输入任务名称"
              clearable
              style="width: 160px">
            </el-input>
          </el-form-item>
          <el-form-item label="任务类型">
            <el-select
              v-model="searchForm.taskType"
              placeholder="请选择任务类型"
              clearable
              style="width: 160px">
              <el-option label="全部" value=""></el-option>
              <el-option label="波形" value="1"></el-option>
              <el-option label="网关" value="2"></el-option>
              <el-option label="断路器" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理状态">
            <el-select
              v-model="searchForm.handleStatus"
              placeholder="请选择处理状态"
              clearable
              style="width: 160px">
              <el-option label="处理中" value="1"></el-option>
              <el-option label="处理完成" value="2"></el-option>
              <el-option label="处理失败" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="searchForm.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 350px">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="view-button-group">
            <div class="button-wrapper">
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索 / 刷新</el-button>
              <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
            </div>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          max-height="450px"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="{ backgroundColor: '#fafafa', color: '#606266', fontWeight: 600, fontSize: '14px', padding: '12px 0' }">
          <el-table-column
            prop="taskName"
            label="任务名称"
            min-width="200"
            align="center">
          </el-table-column>
          <el-table-column
            prop="fileSize"
            label="文件大小"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.fileSize }}
                {{ scope.row.fileSize? 'MB' : '-' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taskType"
            label="任务类型"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>
                {{ getTaskTypeText(scope.row.taskType) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="handleStatus"
            label="处理状态"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span :class="['status-tag', getHandleStatusClass(scope.row.handleStatus)]">
                {{ getHandleStatusText(scope.row.handleStatus) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="100"
            align="center"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDownload(scope.row)"
                :disabled="scope.row.handleStatus == 1 || scope.row.handleStatus == 3">
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="view-pagination" v-if="tableData.length > 0">
          <PageButton
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :current-page="pagination.currentPage"
            @pageChange="handleCurrentChange"
            @sizeChange="handleSizeChange">
          </PageButton>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" type="primary">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageButton from '@/components/buttons/PageButton.vue'
import { taskManageList } from '@/api/task/manage'

export default {
  name: "TaskCenter",
  components: {
    PageButton
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      searchForm: {
        taskName: "",
        taskType: "",
        handleStatus: "",
        timeRange: [],
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.fetchData();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm = {
        taskName: "",
        taskType: "",
        handleStatus: "",
        timeRange: [],
      };
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      const params = {
        page: this.pagination.currentPage,
        size: this.pagination.pageSize,
        taskName: this.searchForm.taskName || undefined,
        taskType: this.searchForm.taskType || undefined,
        handleStatus: this.searchForm.handleStatus || undefined,
      };
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.startTime = this.searchForm.timeRange[0];
        params.endTime = this.searchForm.timeRange[1];
      }
      taskManageList(params).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
          
          // 计算处理中的任务数量
          const processingCount = this.tableData.filter(item => item.handleStatus === 1).length;
          this.$emit('update-processing-count', processingCount);
        }
      }).catch(err => {
        this.loading = false;
        // this.$message.error('获取任务列表失败');
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
    handleDownload(row) {
      if (!row.obsUrl) {
        this.$message.error('下载地址不存在');
        return;
      }

      // 直接创建下载链接，使用浏览器默认下载
      const link = document.createElement('a');
      link.href = row.obsUrl;
      link.download = row.taskName; // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$message.success('开始下载：' + row.taskName);
    },
    
    getTaskTypeText(type) {
      const map = {
        1: "波形",
        2: "网关",
        3: "断路器",
      };
      return map[type] || type;
    },
    getHandleStatusText(status) {
      const map = {
        1: "处理中",
        2: "处理完成",
        3: "处理失败",
      };
      return map[status] || status;
    },
    getHandleStatusClass(status) {
      const map = {
        1: "status-pending",
        2: "status-success",
        3: "status-failed",
      };
      return map[status] || "status-unknown";
    },
  },
};
</script>

<style scoped>
.tab-content {
  padding: 0;
}

.task-center-dialog >>> .el-dialog__body {
  padding: 20px;
}

.task-center-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.view-search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
}

.view-button-group {
  margin-left: auto;
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.button-wrapper {
  display: flex;
  gap: 8px;
}

.view-pagination {
  display: flex;
  justify-content: right;
}

.el-button:disabled {
  opacity: 0.4;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.status-pending {
  color: #f2a606;
}

.status-processing {
  color: #3fadb8;
}

.status-success {
  color: #52c41a;
}

.status-failed {
  color: #ff4d4f;
}

.status-unknown {
  color: #999;
}

.status-waveform {
  color: #52c41a;
}

.status-gateway {
  color: #f2a606;
}

.status-breaker {
  color: #3fadb8;
}
</style>
